<template>
  <v-layout wrap style="font-size: 18px;">
    <v-flex xs12 md10 offset-md1>
      <v-toolbar dense color="primary" dark>
        <v-spacer></v-spacer>
        <v-btn flat dark style="margin: 0px" @click="$router.go(-1)">
          <v-icon>reply</v-icon>{{ $t('Button.back') }}
        </v-btn>
        <v-toolbar-title slot="extension" class="display-2 page_title" pb-2>
          <v-icon x-large style="padding-bottom: 10px" left>cloud_download</v-icon>
          Map Layer : {{ name }}
        </v-toolbar-title>
      </v-toolbar>
      <br>
      <v-layout>
        <v-flex xs6 pr-3>
          <v-card>
            <v-toolbar dense dark color="secondary">
              <v-toolbar-title>Map Layer</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <!-- <v-layout> -->
              <!-- <v-flex xs6> -->
              <v-text-field label="Name" v-model="mapLayerData.LayerName"></v-text-field>
              <v-text-field label="DisplayName" v-model="mapLayerData.DisplayName"></v-text-field>
              <v-switch v-model="mapLayerData.ShowOnLoad" :label="`ShowLoading : ${mapLayerData.ShowOnLoad.toString()}`"></v-switch>
              <v-select v-model="mapLayerData.Ordinal" :items="getOrdinal" label="Ordinal"></v-select>
              <!-- </v-flex> -->
              <!-- </v-layout> -->
            </v-card-text>
            <v-card-actions>
              <v-btn class="btn_save" color="success" @click="clickSave()">
                <v-icon class="mr-1">done</v-icon>{{ $t('Button.Save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs6 pl-3>
          <MapServiceManage v-model="mapLayerData" />
        </v-flex>
      </v-layout>
    </v-flex>

    <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
    </v-snackbar>

    <ErrorDialog v-model="errorDialog.show" :data="errorDialog.data" :title="errorDialog.title"></ErrorDialog>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import SnackBarUtil from '../mixins/SnackBarUtil'
  import ErrorDialog from '@/components/generic/ErrorDialog'
  import MapServiceManage from './AdministrationMapServiceManage'
  const app = createNamespacedHelpers('app')

  export default {
    components: {
      MapServiceManage,
      ErrorDialog,
    },
    mixins: [SnackBarUtil],
    props: {
      name: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        mapLayerName: this.$route.params.name,
      }
    },
    mounted() {},
    computed: {
      ...app.mapGetters(['newMapServiceConfigs']),
      mapLayerData() {
        return this.newMapServiceConfigs.find(x => x.LayerName == this.mapLayerName)
      },
      getOrdinal() {
        let arr = []
        let length = this.newMapServiceConfigs.length
        for (var i = 1; i <= length; i++) {
          arr.push(i)
        }
        return arr
      },
      errorDialog() {
        return this.$store.getters['app/errorDialog']
      },
    },
    watch: {},
    methods: {
      ...app.mapActions(['updateMapLayer']),
      clickSave() {
        if (this.mapLayerData.LayerName && this.mapLayerData.DisplayName && this.mapLayerData.Ordinal) {
          let options = {
            data: {
              Id: this.mapLayerData.Id,
              LayerName: this.mapLayerData.LayerName,
              DisplayName: this.mapLayerData.DisplayName,
              ShowOnLoad: this.mapLayerData.ShowOnLoad,
              Ordinal: this.mapLayerData.Ordinal,
              RoleMapId: this.mapLayerData.RoleMapId,
            },
            successCb: () => {
              this.handleNotification({
                type: 'success',
                message: 'Save success',
              })
            },
            failedCb: (err) => {
              this.$store.dispatch('app/setErrorDialog', {
                data: err.response.data,
                title: err,
                show: true,
              })
            },
          }
          this.updateMapLayer(options)
        } else {
          this.handleNotification({
            type: 'error',
            message: 'Can not be null, please look over.',
          })
        }
      },
    },
  }
</script>

<style scoped lang="stylus">
  .btn_save {
    margin: 0 auto;
    display: block;
    width: 30%;
  }
</style>